/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { RouteComponent } from "vue-router";
import type { LastLevelRouteKey, RouteLayout } from "@elegant-router/types";


export const layouts: Record<RouteLayout, RouteComponent | (() => Promise<RouteComponent>)> = {
  base: () => import("@/layouts/base-layout/index.vue"),
  blank: () => import("@/layouts/blank-layout/index.vue"),
};

export const views: Record<LastLevelRouteKey, RouteComponent | (() => Promise<RouteComponent>)> = {
  403: () => import("@/views/_builtin/403/index.vue"),
  404: () => import("@/views/_builtin/404/index.vue"),
  500: () => import("@/views/_builtin/500/index.vue"),
  login: () => import("@/views/_builtin/login/index.vue"),
  affiliate: () => import("@/views/affiliate/index.vue"),
  "api-keys": () => import("@/views/api-keys/index.vue"),
  billing_addresses: () => import("@/views/billing/addresses/index.vue"),
  billing_credit: () => import("@/views/billing/credit/index.vue"),
  billing_history: () => import("@/views/billing/history/index.vue"),
  billing_invoices: () => import("@/views/billing/invoices/index.vue"),
  billing_packages: () => import("@/views/billing/packages/index.vue"),
  calculator: () => import("@/views/calculator/index.vue"),
  home: () => import("@/views/home/index.vue"),
  limits: () => import("@/views/limits/index.vue"),
  "model-studio_compare": () => import("@/views/model-studio/compare/index.vue"),
  "model-studio_overview": () => import("@/views/model-studio/overview/index.vue"),
  "model-studio_playground": () => import("@/views/model-studio/playground/index.vue"),
  "model-studio_prompts": () => import("@/views/model-studio/prompts/index.vue"),
  "model-studio_requests": () => import("@/views/model-studio/requests/index.vue"),
  "model-studio_workflows": () => import("@/views/model-studio/workflows/index.vue"),
  models: () => import("@/views/models/index.vue"),
  sponsorship_apply: () => import("@/views/sponsorship/apply/index.vue"),
  sponsorship_home: () => import("@/views/sponsorship/home/index.vue"),
  sponsorship_levels: () => import("@/views/sponsorship/levels/index.vue"),
  sponsorship_status: () => import("@/views/sponsorship/status/index.vue"),
  "support_ai-operations": () => import("@/views/support/ai-operations/index.vue"),
  "support_all-tickets": () => import("@/views/support/all-tickets/index.vue"),
  "support_create-ticket": () => import("@/views/support/create-ticket/index.vue"),
  support_dashboard: () => import("@/views/support/dashboard/index.vue"),
  "support_knowledge-base": () => import("@/views/support/knowledge-base/index.vue"),
  "support_my-tickets": () => import("@/views/support/my-tickets/index.vue"),
  tokenizer: () => import("@/views/tokenizer/index.vue"),
  usage_overview: () => import("@/views/usage/overview/index.vue"),
  usage_reports: () => import("@/views/usage/reports/index.vue"),
};
